import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { ProListingComponent } from './pro-listing.component';
import { ProListingPageGuard } from './pro-listing-page.guard.guard';

export const routes: Routes = [
  {
    path: ``,
    data: {
      isFullHeader: true
    },
    children : [
      {
        path: '',
        component: ProListingComponent,
        pathMatch: 'full',
      },
      {
        path: 'page',
        data: {
          isFullHeader: true
        },
        children: [
          {
            path: ':page',
            pathMatch: 'full',
            canActivate: [
              ProListingPageGuard
            ],
            component: ProListingComponent,
          }
        ]
      },
    ]
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    LocalizeRouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
    LocalizeRouterModule
  ]
})
export class ProfessionalListingRoutingModule {
}
